export var mfRegistrationBookMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                acCode: item.acCode,
                schemeName: item.schemeName,
                sipTenure: item.siP_Tenure,
                mq: item.mq,
                endDate: item.endDate,
                spiPaid: item.sipPaid,
                sipRejected: item.sipRejected,
                nextDueDate: item.nextDueDate,
                sipPending: item.sippEnding,
                amount: item.amount,
                totalInvestment: item.totalInvestment,
                mandateID: item.mandateID,
                mandateStatus: item.mandateStatus,
                sipStatus: item.siP_STATUS,
                exchange: item.exchange,
                sipRegnNo: item.sipRegnNo,
            };
        });
    }
    console.log(" mfRegistrationData mapper", result);
    return result;
};
